import * as React from "react";
import { useRef } from "react";
import { Col, Row } from "components/bootstrap";
import ElementDimensions from "components/common/ElementDimensions";
import useCurrentQueryId from "views/logic/queries/useCurrentQueryId";
import QueryTitleEditModal from "./queries/QueryTitleEditModal";
import AdaptableQueryTabs from "./AdaptableQueryTabs";
const QueryTabs = ({ onRemove, onSelect, onTitleChange, queries, titles, dashboardId }) => {
  const queryTitleEditModal = useRef();
  const activeQueryId = useCurrentQueryId();
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(ElementDimensions, null, ({ width }) => width ? /* @__PURE__ */ React.createElement(
    AdaptableQueryTabs,
    {
      maxWidth: width,
      queries,
      dashboardId,
      titles,
      onRemove,
      onSelect,
      queryTitleEditModal,
      onTitleChange
    }
  ) : /* @__PURE__ */ React.createElement("div", null)), /* @__PURE__ */ React.createElement(
    QueryTitleEditModal,
    {
      onTitleChange: (newTitle) => onTitleChange(activeQueryId, newTitle),
      ref: queryTitleEditModal
    }
  )));
};
export default QueryTabs;
